import { READ_PROGRESS_BEGIN, READ_PROGRESS_SUCCESS, READ_PROGRESS_ERROR } from './actions';

const initialState = {
    data: [],
    loading: false,
    error: null,
};

const ProgressReducer = (state = initialState, action) => {
    switch (action.type) {
        case READ_PROGRESS_BEGIN:
            return {
                ...state,
                loading: true,
            };
        case READ_PROGRESS_SUCCESS:
            return {
                ...state,
                data: action.payload,
                error: false,
                loading: false,
            };
        case READ_PROGRESS_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false,
            };
        default:
            return state;
    }
};


export { ProgressReducer };
